import { render, staticRenderFns } from "./InviteVendor.vue?vue&type=template&id=a47dff5a&scoped=true&"
import script from "./InviteVendor.vue?vue&type=script&lang=js&"
export * from "./InviteVendor.vue?vue&type=script&lang=js&"
import style0 from "./InviteVendor.vue?vue&type=style&index=0&id=a47dff5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47dff5a",
  null
  
)

export default component.exports